// Store subdomains: {slug}.lojapilot.pt resolves the store with slug
// {slug}. A per-store origin gives each store PWA its own manifest, service
// worker scope and storage — no install/state conflicts between stores.

const PLATFORM_DOMAIN = (import.meta.env.VITE_PLATFORM_DOMAIN || 'lojapilot.pt').toLowerCase();

// Subdomains that serve the platform itself, never a store.
const RESERVED_SUBDOMAINS = new Set([
  'www', 'app', 'api', 'mail', 'webmail', 'cpanel', 'ftp', 'smtp', 'pop', 'imap',
  'ns1', 'ns2', 'cdn', 'static', 'admin', 'dashboard', 'dev', 'staging', 'docs', 'blog',
]);

// Returns the store slug encoded in a {slug}.{platform} hostname, or ''.
export function getStoreSubdomainSlug(hostname: string): string {
  const h = (hostname || '').toLowerCase();
  if (!h.endsWith(`.${PLATFORM_DOMAIN}`)) return '';
  const sub = h.slice(0, -(PLATFORM_DOMAIN.length + 1));
  if (!sub || sub.includes('.') || RESERVED_SUBDOMAINS.has(sub)) return '';
  if (!/^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/.test(sub)) return '';
  return sub;
}

// Hostnames that serve the platform app — anything else is a store domain
// (custom domain OR store subdomain) whose traffic belongs to that store.
export function isMasterHost(hostname: string): boolean {
  const h = (hostname || '').toLowerCase();
  if (h === 'localhost' || h === '127.0.0.1' ||
      h.includes('vercel.app') || h.includes('supabase.co') ||
      h === 'woo.goldencreative.pt' || h === 'woo.swiftapps.cloud') {
    return true;
  }
  if (h === PLATFORM_DOMAIN || h === `www.${PLATFORM_DOMAIN}`) return true;
  // Store subdomains are NOT the master app — every other *.platform host is.
  if (h.endsWith(`.${PLATFORM_DOMAIN}`)) return !getStoreSubdomainSlug(h);
  return false;
}
